<template>
  <div>
    <b-card no-body class="my-2">
      <b-card-header class="card-header-results border-0">
        <div
          class="card-header-result-name"
          @click="toggleCollapse()">
          <b-icon
            variant="primary"
            :icon="collapsed ? 'dash-square' : 'plus-square'"
            class="mr-2" />
          <span style="font-size:16px;">
            <strong class="mr-2">{{result.name}}</strong>
            <sup class="text-warning">
              <span v-for="star in result.stars" :key="star">
                <b-icon icon="star-fill" />
              </span>
            </sup>
          </span>
          <h6 class="text-primary d-inline ml-2"><small>{{result.extraStars}}</small></h6>
        </div>
        <div class="price-and-status">
          <span class="price-start-at"><translate>from</translate>: {{ getFullPrice({ meal: displayedMeal, starRating: result.stars, fees }) }} {{ params.currency }}</span>
          <span class="price-off" v-if="displayedMeal.discount"><translate>sale</translate>: {{ getPrice({ meal: displayedMeal, starRating: result.stars, fees }) }} {{ params.currency }}</span>
          <span v-if="status =='AVL'" class="FCAVL">{{ status }}</span>
          <span v-if="status =='RQ'" class="RQNA">{{ status }}</span>
          <span v-if="status =='N/A'" class="RQNA">{{ status }}</span>

            <b-button variant="outline-danger" @click="$emit('toggle')" size="sm" class="mx-2">
              <b-iconstack>
                <b-icon icon="square" scale="0.8" stacked />
                <b-icon icon="check" v-if="selected" scale="0.7" stacked />
              </b-iconstack>
              PDF
            </b-button>
            <b-button variant="primary" class="custom-primary" @click="$emit('info')" size="sm">
              <b-icon icon="info-circle-fill" />
            </b-button>

        </div>
      </b-card-header>
      <b-card-body v-if="collapsed" class="bg-light">
        <b-row>
          <b-col md="4">
            <b-card no-body class="bg-light mb-4 mb-sm-0 border-0 shadow-sm">
              <b-carousel
                id="carousel"
                controls
                indicators
                v-if="result.images.length"
              >
                <b-carousel-slide v-for="(image,imageIndex) in result.images" :key="imageIndex">
                  <template slot="img">
                    <img :src="image.url" class="img-fluid w-100 d-block carousel-img" @click="open"/>
                  </template>
                </b-carousel-slide>
              </b-carousel>
              <template v-else>
                <img :src="result.image.url" v-if="result.image" class="img-fluid w-100 d-block carousel-img" />
                <img v-else src="@/assets/images/backgrounds/default-image.jpg" class="img-fluid" />
              </template>
            </b-card>
          </b-col>
          <b-col md="8">
            <div class="d-flex justify-content-between result-summary p-2 mb-3">
              <span><span class="mr-2"><b v-translate>Area:</b> </span>{{ result.locationName }}</span><br/>
              <span><span class="mr-2"><b v-translate>Destination:</b> </span>{{ params.resortName }}</span><br/>
              <span><span class="mr-2"><b v-translate>Country:</b> </span>{{ params.countryName }}</span>
            </div>
            <h5 class="border-bottom pb-2 text-center">
              <span class="mr-2">{{result.name}}</span>
               <sup class="text-warning">
                <span v-for="star in result.stars" :key="star">
                  <b-icon icon="star-fill" />
                </span>
              </sup>
            </h5>
            <div class="d-flex justify-content-end mb-2 border-bottom pb-2"  v-if="result.url">
              <small>
                <a :href="result.url" target="_blank">{{ result.url }}</a>
              </small>
            </div>
            <p v-if="result.descriptionIsHtml" v-html="result.description"></p>
            <p style="white-space: pre-line;" v-else>{{ result.description }}</p>
          </b-col>
        </b-row>
        <slot></slot>
      </b-card-body>
    </b-card>
    <b-modal v-model="modal" title="Modal Info" size="xl" hide-header hide-footer centered id="lightbox">
      <b-row>
        <b-col class="mx-auto" md="8">
          <div class="d-flex justify-content-end mb-3">
            <b-button class="btn btn-dark btn-sm btn-lightbox" @click="close" v-b-tooltip.hover title="Close">
              <b-icon icon="x" />
            </b-button>
          </div>
          <b-card no-body>
              <b-carousel
                id="carousel"
                controls
                indicators
                background="#FFF"
                v-if="result.images.length"
              >
                <b-carousel-slide v-for="(image,imageIndex) in result.images" :key="imageIndex">
                  <template slot="img">
                    <img :src="image.url" class="img-fluid w-100 d-block carousel-img"/>
                  </template>
                </b-carousel-slide>
              </b-carousel>
              <img v-else src="@/assets/images/backgrounds/default-image.jpg" class="img-fluid" />
            </b-card>
        </b-col>
      </b-row>
    </b-modal>
  </div>
</template>
<script>
import { getFullPrice, getPrice } from 'b2b-common/utils/hotel'

export default {
  name: 'SearchResult',
  props: {
    params: Object,
    result: Object,
    selected: Boolean,
    expanded: Boolean,
    displayedMeal: Object,
    fees: {
      type: Object,
      required: false,
      default: () => { return {} }
    }
  },
  data () {
    return {
      collapsed: this.expanded,
      modal: false
    }
  },
  methods: {
    toggleCollapse () {
      this.collapsed = !this.collapsed
    },
    getFullPrice,
    getPrice,
    close () {
      this.modal = false
    },
    open () {
      this.modal = true
    }
  },
  computed: {
    status () {
      let isAvl = false
      let isNa = true

      const categoriesMap = (data, flight) => {
        const flightIsOnRequest = flight?.isOnRequest ?? false
        data.categories.map(cat => {
          if (cat.hotelIsAvailable && !cat.hotelIsBlackedOut && !flightIsOnRequest) isAvl = true
          if (!cat.hotelIsBlackedOut) isNa = false
        })
      }

      if (this.result.packages) {
        this.result.packages.map(pack => {
          categoriesMap(pack, pack.flightInfo)
        })
      } else {
        categoriesMap(this.result)
      }

      if (isAvl) return 'AVL'
      else if (isNa) return 'N/A'
      else return 'RQ'
    }
  }
}
</script>

<style lang="css">
  #lightbox .modal-content,
  #lightbox .modal-content .card {
    background:rgba(255,25,255,0);
    border: none;
  }
  .btn-lightbox{
    border:2px solid #fff;
  }
</style>
